import { Container, styled } from '@mui/material';

export const EmptyLayoutStyled = styled(Container)(() => ({
	minHeight: 'calc(100vh - 64px)',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexDirection: 'column',
}));
